import backgroundLuckyWheelImage from '@/assets/images/backgroundLuckyWheel.jpg';
import backgroundLuckyWheelDeskImage from '@/assets/images/backgroundLuckyWheelDesk.jpg';
import IcatuImage from '@/assets/images/icatuLogo.png';
import SbtPremiosWheelLogo from '@/assets/images/sbtGold.png';
import SbtPremiosLogo from '@/assets/images/SbtPremiosLogo.png';
import { Colors } from '@/brands/ouroPix/colors';
import { type WhitelabelConfig } from '@/brands/types';

import type { Metadata } from 'next';

export const ouroPixMetaData: Metadata = {
  title: 'Pix do Milhão!',
  description: 'Plataforma de apostas',
  metadataBase: new URL('https://pixdomilhao.com'),
  openGraph: {
    title: 'Pix do Milhão!',
    description: 'Ganhe milhões apostando com sabedoria!',
    url: 'https://pixdomilhao.com',
    siteName: 'Pix do Milhão',
    images: [
      {
        url: '/images/OuroPixBanner.jpeg',
        width: 1200,
        height: 630,
        alt: 'Pix do Milhão',
      },
    ],
    locale: 'pt_BR',
    type: 'website',
  },
  icons: {
    icon: '/favicon/favicon.png',
    apple: '/favicon/favicon.png',
  },
  robots: {
    index: true,
    follow: true,
    nocache: false,
  },
  twitter: {
    card: 'summary_large_image',
    title: 'Pix do Milhão',
    description: 'Ganhe milhões apostando com sabedoria!',
    images: ['/images/OuroPixBanner.jpeg'],
  },
};

// TODO: add checkoutCheckboxes in WhitelabelConfig
export const ouroPixConfig: WhitelabelConfig = {
  name: 'ouroPix',
  displayName: 'Ouro Pix',
  latestWinnersVideos: [],
  assets: {
    logo: SbtPremiosLogo.src,
    logoHeader: SbtPremiosLogo.src,
    logoMenu: SbtPremiosLogo.src,
    logoFooter: SbtPremiosLogo.src,
    logoWheel: SbtPremiosWheelLogo.src,
    luckyWheelBackground: backgroundLuckyWheelImage.src,
    luckyWheelBackgroundDesktop: backgroundLuckyWheelDeskImage.src,
  },
  capitalizer: {
    link: 'https://capitalizacao.icatuseguros.com.br/',
    displayName: 'Icatu Capitalização S.A.',
    logoFooter: IcatuImage.src,
  },
  colors: Colors,
  meta: {
    description: 'Ouro Pix',
    baseUrl: 'https://pixdomilhao.com',
    ogImage: '/images/OuroPixBanner.jpeg',
    favicon: '/favicon/favicon.png',
    appleIcon: '/favicon/favicon.png',
  },
  checkoutCheckboxes: {
    marketingOptIn: {
      visible: true,
      required: true,
      label: 'Aceito receber comunicações de marketing e ofertas',
      errorMessage: 'Você deve aceitar receber comunicações de marketing',
    },
    termsOfService: {
      visible: true,
      required: true,
      label: 'Concordo com os termos',
      errorMessage: 'Você deve concordar com os Termos de Uso',
      prefixText: 'Concordo com a',
      brandText: 'do Ouro Pix',
      links: [
        { text: 'Política de Privacidade', href: '/politica-de-privacidade' },
        { text: 'Termos de Uso', href: '/termos-de-uso' },
      ],
    },
  },
};
